import { render, staticRenderFns } from "./CrmEdit.vue?vue&type=template&id=82889f52&scoped=true"
import script from "./CrmEdit.vue?vue&type=script&lang=ts"
export * from "./CrmEdit.vue?vue&type=script&lang=ts"
import style0 from "./CrmEdit.vue?vue&type=style&index=0&id=82889f52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82889f52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82889f52')) {
      api.createRecord('82889f52', component.options)
    } else {
      api.reload('82889f52', component.options)
    }
    module.hot.accept("./CrmEdit.vue?vue&type=template&id=82889f52&scoped=true", function () {
      api.rerender('82889f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmEdit.vue"
export default component.exports